import addAccomAndExtras from './addAccomAndExtras';
import addAccommodationExtrasToBasketSaga from './addAccommodationExtras';
import addAccommodationToBasketSaga from './addAccommodation';
import addExtrasToBasketSaga from './addExtras';
import addNameChangeToBasketSaga from './addNameChange';
import addTicketsToBasketSaga from './addTickets';
import addTransportToBasketSaga from './addTransport';
import checkBasketSaga from './checkBasket';
import completeZeroValueBasketSaga from './completeZeroValueBasket';
import createBasketSaga from './createBasket';
import getBasketSaga from './getBasket';
import removeAccommodationSaga from './removeAccommodation';
import removeExtraSaga from './removeExtra';
import removeItemsSaga from './removeItems';
import resetBasketSaga from './resetBasket';

export const basketSagas = [
  addAccomAndExtras,
  addAccommodationToBasketSaga,
  addAccommodationExtrasToBasketSaga,
  addExtrasToBasketSaga,
  addTicketsToBasketSaga,
  addTransportToBasketSaga,
  addNameChangeToBasketSaga,
  checkBasketSaga,
  completeZeroValueBasketSaga,
  createBasketSaga,
  getBasketSaga,
  removeAccommodationSaga,
  removeExtraSaga,
  resetBasketSaga,
  removeItemsSaga,
];
